// File: src/pages/production/Wastageproduction.jsx
import React from "react";
import {
  Label,
  Card,
  CardBody,
  Input,
  Row,
  Modal,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  Badge,
  Table,
  Spinner,
} from "reactstrap";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { ImDownload } from "react-icons/im";
import { Eye, Edit } from "react-feather";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import {
  FaArrowAltCircleLeft,
  FaArrowAltCircleRight,
  FaFilter,
} from "react-icons/fa";
import UserContext from "../import/context/Context";
import { _Get } from "../import/ApiEndPoint/ApiCalling";
import { CheckPermission } from "../import/CheckPermission";
import { Get_Producton_ProcessList } from "../import/ApiEndPoint/Api";
import SuperAdminUI from "../import/SuperAdminUI";

// ======================================================
// Helpers
// ======================================================
const SelectedColums = []; // temp selection bucket in the columns modal
const safe = (v) => (v === undefined || v === null ? "" : v);

// ======================================================
// Component
// ======================================================
class Wastageproduction extends React.Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      Loading: false,

      // data
      rowData: [],
      startDate: "",
      EndDate: "",

      // permissions
      InsiderPermissions: {},
      MasterShow: false,

      // UI
      isOpen: false, // download dropdown open
      modal: false, // columns modal
      modalone: false, // details modal
      Arrindex: -1,

      // details
      ViewOneUserView: false,
      ViewOneData: {},
      Gst: 0, // sum(price*qty) for details

      // columns & table
      AllcolumnDefs: [],
      SelectedcolumnDefs: [],
      searchText: "",
      paginationPageSize: 15,
      currentPage: 1,
      sortConfig: { key: "UID", direction: "asc" },
    };
  }

  // ---------------------------------------------
  // Columns (id, header, getters)
  // ---------------------------------------------
  baseColumns = [
    {
      id: "UID",
      headerName: "UID",
      getValue: (_row, _localIdx, absoluteIdx) => absoluteIdx + 1,
      exportable: true,
    },
    {
      id: "actions",
      headerName: "Actions",
      render: (row) => {
        const canEdit = this.state.InsiderPermissions?.View;
        const canView = this.state.InsiderPermissions?.Edit;
        return (
          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            {canView && (
              <Eye
                className="mr-50"
                size={20}
                color="green"
                onClick={() => {
                  this.toggleDetails();
                  this.handleChangeView(row, "readonly");
                }}
                style={{ cursor: "pointer" }}
                title="View"
              />
            )}
            {canEdit && (
              <a
                href={`#/app/freshlist/order/EditProductionProcess/${row?._id}`}
                title="Edit"
                style={{ display: "inline-flex", alignItems: "center" }}
              >
                <Edit className="mr-50" size={20} color="blue" />
              </a>
            )}
          </div>
        );
      },
      exportable: false,
    },
    {
      id: "productName",
      headerName: "Product Name",
      getValue: (row) => safe(row?.product_name?.Product_Title),
      exportable: true,
    },
    {
      id: "productReq",
      headerName: "Product Req",
      getValue: (row) => `${safe(row?.productItems?.length) || 0} Products`,
      exportable: true,
    },
    {
      id: "productTotal",
      headerName: "Product Total",
      getValue: (row) => Number(row?.grandTotal || 0),
      exportable: true,
    },
    {
      id: "gst",
      headerName: "GST",
      getValue: (row) => Number(row?.gstApplied || 0),
      exportable: true,
    },
    {
      id: "misc",
      headerName: "Miscellaneous Expennses",
      getValue: (row) => Number(row?.miscellaneousExpennses || 0),
      exportable: true,
    },
    {
      id: "otherCharges",
      headerName: "Other Charges",
      getValue: (row) => Number(row?.otherCharges || 0),
      exportable: true,
    },
    {
      id: "discount",
      headerName: "Discount",
      getValue: (row) => Number(row?.discount || 0),
      exportable: true,
    },
    {
      id: "grandTotal",
      headerName: "grand Total",
      getValue: (row) => Number(row?.grandTotal || 0),
      exportable: true,
    },
  ];

  // ---------------------------------------------
  // Lifecycle
  // ---------------------------------------------
  async componentDidMount() {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    if (userInfo?.rolename?.roleName === "MASTER") {
      this.setState({ MasterShow: true });
    }

    const InsidePermissions = CheckPermission("Wastage Material");
    this.setState({ InsiderPermissions: InsidePermissions });

    // init columns (try localStorage first by headerName)
    const saved = JSON.parse(
      localStorage.getItem("ProductionProcessList") || "null"
    );
    if (Array.isArray(saved) && saved.length) {
      const byHeader = Object.fromEntries(
        this.baseColumns.map((c) => [c.headerName, c])
      );
      const selected = saved
        .map((s) => byHeader[s?.headerName])
        .filter(Boolean);
      this.setState({
        AllcolumnDefs: this.baseColumns,
        SelectedcolumnDefs: selected.length ? selected : this.baseColumns,
      });
    } else {
      this.setState({
        AllcolumnDefs: this.baseColumns,
        SelectedcolumnDefs: this.baseColumns,
      });
    }

    // load data
    await this.fetchList(userInfo?._id, userInfo?.database);
  }

  // ---------------------------------------------
  // Data load
  // ---------------------------------------------
  fetchList = async (id, db) => {
    try {
      this.setState({ Loading: true });
      const url = `${Get_Producton_ProcessList}/${id}/`;
      const res = await _Get(url, db);
      const arr = res?.Production || [];
      this.setState({ rowData: arr });
    } catch (err) {
      console.error(err);
      this.setState({ rowData: [] });
    } finally {
      this.setState({ Loading: false });
    }
  };

  // ---------------------------------------------
  // Details modal handlers
  // ---------------------------------------------
  toggleDetails = () => this.setState((p) => ({ modalone: !p.modalone }));

  handleChangeView = (data, types) => {
    if (types === "readonly") {
      let amt = 0;
      const list = data?.wastageItems || [];
      if (list.length) {
        amt = list
          .map((v) => Number(v?.price || 0) * Number(v?.qty || 0))
          .reduce((a, b) => a + b, 0);
      }
      this.setState({ ViewOneUserView: true, ViewOneData: data, Gst: amt });
    }
  };

  // ---------------------------------------------
  // Search / sort / pagination
  // ---------------------------------------------
  updateSearchQuery = (val) =>
    this.setState({ searchText: val, currentPage: 1 });

  filteredSortedRows = () => {
    const { rowData, searchText, SelectedcolumnDefs, sortConfig } = this.state;
    // search
    const q = String(searchText || "").toLowerCase();
    const searched = (rowData || []).filter((row) => {
      if (!q) return true;
      const parts = [
        safe(row?.product_name?.Product_Title),
        safe(row?.grandTotal),
        safe(row?.gstApplied),
        safe(row?.miscellaneousExpennses),
        safe(row?.otherCharges),
        safe(row?.discount),
        safe(row?.productItems?.length),
      ];
      return parts.some((p) => String(p).toLowerCase().includes(q));
    });

    // sort (ignore actions)
    const key = sortConfig?.key;
    const dir = sortConfig?.direction === "desc" ? -1 : 1;
    const col = (SelectedcolumnDefs || []).find((c) => c.id === key);
    const data = [...searched];
    if (col && col.id !== "actions") {
      data.sort((a, b) => {
        const av = col.getValue ? col.getValue(a) : "";
        const bv = col.getValue ? col.getValue(b) : "";
        const na = typeof av === "number";
        const nb = typeof bv === "number";
        if (na && nb) return (av - bv) * dir;
        return String(av).localeCompare(String(bv)) * dir;
      });
    }
    return data;
  };

  setPageSize = (e) =>
    this.setState({
      paginationPageSize: Number(e.target.value || 15),
      currentPage: 1,
    });
  setPage = (n) => this.setState({ currentPage: n });

  sortBy = (colId) => {
    this.setState((prev) => {
      const { sortConfig } = prev;
      let direction = "asc";
      if (sortConfig.key === colId && sortConfig.direction === "asc")
        direction = "desc";
      return { sortConfig: { key: colId, direction } };
    });
  };

  // ---------------------------------------------
  // Date filter (optional — dataset has no explicit date field in this view)
  // ---------------------------------------------
  handleDate = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  // ---------------------------------------------
  // Columns modal
  // ---------------------------------------------
  LookupviewStart = () =>
    this.setState((p) => ({ modal: !p.modal, Arrindex: -1 }));

  handleChangeHeader = (e, value) => {
    if (e.target.checked) SelectedColums.push(value);
    else {
      const idx = SelectedColums.findIndex((x) => x.id === value.id);
      if (idx >= 0) SelectedColums.splice(idx, 1);
    }
  };

  HeadingRightShift = () => {
    const views = this.state.SelectedcolumnDefs.slice();
    const ids = new Set(views.map((c) => c.id));
    SelectedColums.forEach((c) => {
      if (!ids.has(c.id)) views.push(c);
    });
    this.setState({ SelectedcolumnDefs: views });
  };

  handleLeftShift = () => {
    const { Arrindex, SelectedcolumnDefs } = this.state;
    if (Arrindex < 0) return;
    const next = SelectedcolumnDefs.slice();
    next.splice(Arrindex, 1);
    this.setState({ SelectedcolumnDefs: next, Arrindex: -1 });
  };

  shiftElementUp = () => {
    const { Arrindex, SelectedcolumnDefs } = this.state;
    if (Arrindex > 0) {
      const next = SelectedcolumnDefs.slice();
      const el = next.splice(Arrindex, 1)[0];
      next.splice(Arrindex - 1, 0, el);
      this.setState({ SelectedcolumnDefs: next, Arrindex: Arrindex - 1 });
    }
  };

  shiftElementDown = () => {
    const { Arrindex, SelectedcolumnDefs } = this.state;
    if (Arrindex >= 0 && Arrindex < SelectedcolumnDefs.length - 1) {
      const next = SelectedcolumnDefs.slice();
      const el = next.splice(Arrindex, 1)[0];
      next.splice(Arrindex + 1, 0, el);
      this.setState({ SelectedcolumnDefs: next, Arrindex: Arrindex + 1 });
    }
  };

  HandleSetVisibleField = (e) => {
    e.preventDefault();
    // persist by headerName (for backward compatibility)
    const toStore = this.state.SelectedcolumnDefs.map((c) => ({
      headerName: c.headerName,
    }));
    localStorage.setItem("ProductionProcessList", JSON.stringify(toStore));
    this.LookupviewStart();
  };

  // ---------------------------------------------
  // Downloads (PDF/CSV/XLS) – visible columns only
  // ---------------------------------------------
  getVisibleExport = () => {
    const cols = (this.state.SelectedcolumnDefs || []).filter(
      (c) => c.exportable !== false && c.id !== "actions"
    );
    const headers = cols.map((c) => c.headerName);
    const data = this.filteredSortedRows();
    const rows = data.map((row, idx) =>
      cols.map((c) =>
        c.id === "UID" ? idx + 1 : c.getValue ? c.getValue(row, idx, idx) : ""
      )
    );
    return { headers, rows };
  };

  exportCSV = () => {
    const { headers, rows } = this.getVisibleExport();
    const csv = Papa.unparse([headers, ...rows]);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "WastageProduction.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  exportXLS = () => {
    const { headers, rows } = this.getVisibleExport();
    const json = rows.map((r) => {
      const obj = {};
      headers.forEach((h, i) => (obj[h] = r[i]));
      return obj;
    });
    const ws = XLSX.utils.json_to_sheet(json);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "WastageProduction");
    XLSX.writeFile(wb, "WastageProduction.xls");
  };

  exportPDF = () => {
    const { headers, rows } = this.getVisibleExport();
    const doc = new jsPDF("landscape", "mm", "a4");
    doc.setTextColor(5, 87, 97);
    doc.setFontSize(12);
    doc.text("Wastage Material with Product List", 14, 14);
    doc.autoTable({
      head: [headers],
      body: rows,
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [8, 91, 245] },
    });
    doc.save("WastageProduction.pdf");
  };

  // ---------------------------------------------
  // Download dropdown hover
  // ---------------------------------------------
  toggleDropdown = (e) => {
    if (e.type === "mouseenter") {
      clearTimeout(this.hideTimeout);
      this.setState({ isOpen: true });
    } else if (e.type === "mouseleave") {
      this.hideTimeout = setTimeout(
        () => this.setState({ isOpen: false }),
        200
      );
    }
  };

  render() {
    const {
      Loading,
      MasterShow,
      InsiderPermissions,
      isOpen,
      SelectedcolumnDefs,
      paginationPageSize,
      currentPage,
      sortConfig,
      searchText,
      ViewOneUserView,
      ViewOneData,
      Gst,
      AllcolumnDefs,
    } = this.state;

    if (Loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20rem",
          }}
        >
          <Spinner style={{ height: "4rem", width: "4rem" }} color="primary">
            Loading...
          </Spinner>
        </div>
      );
    }

    const fullRows = this.filteredSortedRows();
    const totalPages = Math.max(
      1,
      Math.ceil(fullRows.length / paginationPageSize)
    );
    const start = (currentPage - 1) * paginationPageSize;
    const pageRows = fullRows.slice(start, start + paginationPageSize);

    return (
      <>
        <a href="/#/dashboard" style={{ color: "green", paddingLeft: "10px" }}>
          Home
        </a>{" "}
        / Lead
        <Card className="card-color">
          <Row
            style={{ marginLeft: "3px", marginRight: "3px" }}
            className="card-color"
          >
            <Col>
              <h1
                className="float-left"
                style={{
                  fontWeight: 600,
                  textTransform: "uppercase",
                  fontSize: 22,
                  marginTop: 25,
                }}
              >
                Wastage Material with Product List
              </h1>
            </Col>

            <Col lg="2" style={{ marginTop: 25 }}>
              <div className="table-input">
                <Input
                  className="input-color"
                  placeholder="search item here..."
                  onChange={(e) => this.updateSearchQuery(e.target.value)}
                  value={searchText}
                />
              </div>
            </Col>

            {MasterShow ? (
              <Col lg="3" md="3" xl="3" style={{ marginTop: 25 }}>
                <SuperAdminUI
                  onDropdownChange={(v) =>
                    localStorage.setItem(
                      "SuperadminIdByMaster",
                      JSON.stringify(v)
                    )
                  }
                  onSubmit={() => {
                    const picked = JSON.parse(
                      localStorage.getItem("SuperadminIdByMaster")
                    );
                    if (!picked) return;
                    const id = picked.split(" ")[0];
                    const db = picked.split(" ")[1];
                    this.fetchList(id, db);
                  }}
                />
              </Col>
            ) : (
              <Col />
            )}

            {InsiderPermissions?.View && (
              <Col lg="2" style={{ marginTop: 25 }}>
                <span>
                  <FaFilter
                    style={{ cursor: "pointer" }}
                    title="filter column"
                    size="20px"
                    onClick={this.LookupviewStart}
                    color="#39cccc"
                    className="float-right"
                  />
                </span>

                <span
                  onMouseEnter={this.toggleDropdown}
                  onMouseLeave={this.toggleDropdown}
                >
                  <div
                    className="dropdown-container float-right"
                    style={{ position: "relative" }}
                  >
                    <ImDownload
                      style={{ cursor: "pointer" }}
                      title="download file"
                      size="20px"
                      className="dropdown-button"
                      color="#39cccc"
                    />
                    {isOpen && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 10,
                          border: "1px solid #39cccc",
                          backgroundColor: "white",
                          right: 0,
                        }}
                        className="dropdown-content dropdownmy"
                      >
                        <h5
                          onClick={this.exportPDF}
                          style={{ cursor: "pointer" }}
                          className="mx-1 myactive mt-1"
                        >
                          .PDF
                        </h5>
                        <h5
                          onClick={this.exportCSV}
                          style={{ cursor: "pointer" }}
                          className="mx-1 myactive"
                        >
                          .CSV
                        </h5>
                        <h5
                          onClick={this.exportXLS}
                          style={{ cursor: "pointer" }}
                          className="mx-1 myactive"
                        >
                          .XLS
                        </h5>
                      </div>
                    )}
                  </div>
                </span>
              </Col>
            )}
          </Row>

          <CardBody style={{ marginTop: "0.5rem" }}>
            {/* page controls */}
            <Row className="align-items-center mb-2">
              <Col sm="6">
                <div className="d-flex align-items-center gap-2">
                  <Label className="mb-0 me-2">Page size</Label>
                  <Input
                    type="select"
                    value={paginationPageSize}
                    onChange={this.setPageSize}
                    style={{ width: 90 }}
                  >
                    {[10, 15, 25, 50, 100].map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </Input>
                  <div className="ms-3">
                    <small>
                      Showing {pageRows.length} of {fullRows.length} rows
                    </small>
                  </div>
                </div>
              </Col>
              <Col sm="6" className="d-flex justify-content-end">
                <div className="d-flex align-items-center gap-2">
                  <Button
                    size="sm"
                    disabled={currentPage <= 1}
                    onClick={() => this.setPage(currentPage - 1)}
                  >
                    Prev
                  </Button>
                  <span style={{ minWidth: 80, textAlign: "center" }}>
                    {currentPage} /{" "}
                    {Math.max(
                      1,
                      Math.ceil(fullRows.length / paginationPageSize)
                    )}
                  </span>
                  <Button
                    size="sm"
                    disabled={start + paginationPageSize >= fullRows.length}
                    onClick={() => this.setPage(currentPage + 1)}
                  >
                    Next
                  </Button>
                </div>
              </Col>
            </Row>

            {/* table */}
            <div style={{ overflowX: "auto" }}>
              <Table bordered responsive hover size="sm">
                <thead>
                  <tr>
                    {SelectedcolumnDefs.map((c) => {
                      const sortable = c.id !== "actions";
                      const isActive = sortConfig.key === c.id;
                      const arrow =
                        isActive && sortable
                          ? sortConfig.direction === "asc"
                            ? " ▲"
                            : " ▼"
                          : "";
                      return (
                        <th
                          key={c.id}
                          style={{
                            whiteSpace: "nowrap",
                            cursor: sortable ? "pointer" : "default",
                          }}
                          onClick={() => sortable && this.sortBy(c.id)}
                          title={c.headerName}
                        >
                          {c.headerName}
                          {arrow}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {pageRows.map((row, localIdx) => {
                    const absoluteIdx =
                      (currentPage - 1) * paginationPageSize + localIdx;
                    return (
                      <tr key={row?._id || absoluteIdx}>
                        {SelectedcolumnDefs.map((c) => {
                          if (c.render) {
                            return (
                              <td key={c.id} style={{ whiteSpace: "nowrap" }}>
                                {c.render(row, localIdx, absoluteIdx)}
                              </td>
                            );
                          }
                          const val =
                            c.id === "UID"
                              ? absoluteIdx + 1
                              : c.getValue
                              ? c.getValue(row, localIdx, absoluteIdx)
                              : "";
                          return (
                            <td key={c.id} style={{ whiteSpace: "nowrap" }}>
                              {typeof val === "number" ? val : String(val)}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                  {pageRows.length === 0 && (
                    <tr>
                      <td
                        colSpan={SelectedcolumnDefs.length}
                        className="text-center"
                      >
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
        {/* Columns Modal */}
        <Modal
          isOpen={this.state.modal}
          toggle={this.LookupviewStart}
          style={{ maxWidth: 1050 }}
        >
          <ModalHeader toggle={this.LookupviewStart}>Change Fields</ModalHeader>
          <ModalBody>
            <Row>
              <Col lg="4" md="4" sm="12" xl="4" xs="12">
                <h5>Available Columns</h5>
                <div
                  style={{
                    maxHeight: 360,
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    padding: 8,
                  }}
                >
                  {AllcolumnDefs.map((ele) => (
                    <div
                      key={ele.id}
                      className="mt-1 d-flex align-items-center"
                    >
                      <Input
                        type="checkbox"
                        className="me-2"
                        onChange={(e) => this.handleChangeHeader(e, ele)}
                      />
                      <span>{ele.headerName}</span>
                    </div>
                  ))}
                </div>
              </Col>

              <Col
                lg="2"
                md="2"
                sm="12"
                xl="2"
                xs="12"
                className="d-flex flex-column align-items-center"
              >
                <div className="mt-4">
                  <FaArrowAltCircleRight
                    onClick={this.HeadingRightShift}
                    style={{ cursor: "pointer" }}
                    size="30px"
                  />
                </div>
                <div className="mt-3">
                  <FaArrowAltCircleLeft
                    onClick={this.handleLeftShift}
                    style={{ cursor: "pointer" }}
                    size="30px"
                  />
                </div>
              </Col>

              <Col lg="6" md="6" sm="12" xl="6" xs="12">
                <Row>
                  <Col lg="8" md="8" sm="12" xs="12">
                    <h5>Visible Columns</h5>
                    <div
                      style={{
                        maxHeight: 360,
                        overflowY: "auto",
                        border: "1px solid #ddd",
                        padding: 8,
                      }}
                    >
                      {SelectedcolumnDefs.map((ele, i) => (
                        <div key={ele.id} className="mt-1">
                          <h6
                            onClick={() => this.setState({ Arrindex: i })}
                            style={{
                              cursor: "pointer",
                              padding: "6px 8px",
                              borderRadius: 6,
                              backgroundColor:
                                this.state.Arrindex === i
                                  ? "#e7f0ff"
                                  : "#f8f9fa",
                              border:
                                this.state.Arrindex === i
                                  ? "1px solid #7aa7ff"
                                  : "1px solid #e1e1e1",
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <IoMdRemoveCircleOutline
                              onClick={() => {
                                const next = SelectedcolumnDefs.slice();
                                const delindex = next.findIndex(
                                  (x) => x.id === ele.id
                                );
                                if (delindex >= 0) next.splice(delindex, 1);
                                this.setState({ SelectedcolumnDefs: next });
                              }}
                              style={{ cursor: "pointer" }}
                              size="20px"
                              color="red"
                              className="me-1"
                              title="Remove"
                            />
                            {ele.headerName}
                          </h6>
                        </div>
                      ))}
                    </div>
                  </Col>

                  <Col
                    lg="4"
                    md="4"
                    sm="12"
                    xs="12"
                    className="d-flex flex-column align-items-center"
                  >
                    <div className="mt-4">
                      <Button
                        size="sm"
                        color="primary"
                        onClick={this.shiftElementUp}
                      >
                        Up
                      </Button>
                    </div>
                    <div className="mt-2">
                      <Button
                        size="sm"
                        color="primary"
                        onClick={this.shiftElementDown}
                      >
                        Down
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col>
                <div className="d-flex justify-content-center">
                  <Badge
                    style={{ cursor: "pointer" }}
                    color="primary"
                    onClick={this.HandleSetVisibleField}
                  >
                    Submit
                  </Badge>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
        {/* Details Modal */}
        <Modal
          isOpen={this.state.modalone}
          toggle={this.toggleDetails}
          style={{ maxWidth: 1050 }}
        >
          <ModalHeader toggle={this.toggleDetails}>All Products</ModalHeader>
          <ModalBody className="modalbodyhead">
            {ViewOneUserView ? (
              <>
                <Row>
                  <Col>
                    <Label>Product Name:</Label>
                    <h5>{safe(ViewOneData?.product_name?.Product_Title)}</h5>
                  </Col>
                  <Col>
                    <Label>Grand Total :</Label>
                    <h5>
                      <strong>{Number(Gst || 0)}</strong> Rs/-
                    </h5>
                  </Col>
                </Row>

                <Row className="p-2">
                  <Col>
                    <div className="d-flex justify-content-center">
                      <h4>Wastage Material List</h4>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Table style={{ cursor: "pointer" }} responsive bordered>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product Name</th>
                          <th>Price</th>
                          <th>Unit</th>
                          <th>Quantity</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(ViewOneData?.wastageItems || []).map((ele, i) => (
                          <tr key={`${ele?.productId?._id || "row"}-${i}`}>
                            <th scope="row">{i + 1}</th>
                            <td>{safe(ele?.productId?.Product_Title)}</td>
                            <td>{Number(ele?.price || 0)}</td>
                            <td>{safe(ele?.unitType)}</td>
                            <td>{Number(ele?.qty || 0)}</td>
                            <td>
                              {Number(ele?.price || 0) * Number(ele?.qty || 0)}
                            </td>
                          </tr>
                        ))}
                        {!(ViewOneData?.wastageItems || []).length && (
                          <tr>
                            <td colSpan={6} className="text-center">
                              No items
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </>
            ) : null}
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default Wastageproduction;
